import { render, staticRenderFns } from "./LoanCollateralAssetTradeReceivablesFieldsEdit.vue?vue&type=template&id=a26f6798&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetTradeReceivablesFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetTradeReceivablesFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetTradeReceivablesFieldsEdit.vue?vue&type=style&index=0&id=a26f6798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f6798",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetTradeReceivablesFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports